import { useSelector, useDispatch } from "react-redux";
import { setMotion } from "../redux/chartoptions";
import { useState } from "react";
import IndividualComponentPopup from "./individualcomponentpopup";

let M_avg=0;
let M_min=0;
let M_max=0;

function Motion(){

    const [showModal,setShowModal] = useState(false);

    const myData = useSelector(state => state.api)
 
         let sum=0;
        
         
          M_max = Math.max(...myData.motion);
          M_min = Math.min(...myData.motion);
 
 
         myData.motion.forEach(num =>{
           
             sum = sum + Number(num);
         })

        //  console.log(sum);
         
         M_avg = sum/Object.keys(myData.motion).length;
         

         const dispatch = useDispatch();
         const checked = useSelector(state => state.chartOption.motion)

         const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }
         

    return(
        <>
            <div className="parameter" id="motion1" onClick={showPopup}>
                <div className="label2">
                    <input type="checkbox" id="motio" checked={checked} onChange={(e) => {dispatch(setMotion(e.target.checked))}} />
                    <label htmlFor="motio">Evt</label>
                </div>

                <div className="parameter_ul">
                    <ul>
                        <li type="none">{M_min.toFixed(2)} <br /> min</li>
                        <li type="none">{M_max.toFixed(2)} <br /> max</li>
                        <li type="none">{M_avg.toFixed(2)} <br /> avg</li>
                        
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"#0df49fcc"} />}
        </>
    );
}

export default Motion;